module.exports = __webpack_public_path__ + "img/app-default-banner.3e3e2d20.jpg";